/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import Vue from 'vue';

import datetimeFilter from '@/filters/Datetime';
import conservationCredits from '@/filters/ConservationCredits';

/**
 * Filter initialisation module.
 *
 * Adds filters into Vue instance.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */

Vue.filter('datetime', datetimeFilter);
Vue.filter('cc', conservationCredits);
